import { useResetTenantOnboardingSkipMutation } from 'api/Common/mutation';
import { LOCAL_STORAGE_KEYS } from 'constant/localStorage';
import { Logger } from 'utils/logger';

export const useLogout = () => {
  const { mutateAsync: resetTenantOnboardingSkipAsync } =
    useResetTenantOnboardingSkipMutation();

  const logout = async () => {
    try {
      await resetTenantOnboardingSkipAsync();
    } catch (error) {
      // best-effort before session is cleared
      Logger.error({
        message: 'Error resetting tenant onboarding skip flag',
        data: error,
      });
    } finally {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ID);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.TENANT);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.TIMESHEET_PROJECT_KEY);
      localStorage.removeItem('gettingStartedModalShown');
      localStorage.removeItem('addprojectWidgetShown');
      localStorage.removeItem('payrunWidgetShown');
      localStorage.removeItem('customFormWidgetShown');
      localStorage.removeItem('supplier');
      localStorage.removeItem('multiProject');
      localStorage.removeItem('multiDocketProject');
      localStorage.removeItem('multiDocketSupplier');
      localStorage.removeItem('date');
      localStorage.removeItem('status');
      localStorage.removeItem('isNPSGuideShown');
      localStorage.removeItem(LOCAL_STORAGE_KEYS.BILL_MISMATCH_ALERT);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.TIMESHEET_START_DATE_KEY);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.TIMESHEET_END_DATE_KEY);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.DCT_FILTERS);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.NEW_YEAR);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.SCHEDULAR_MODE);
      sessionStorage.clear();
      // window.open('/login', '_self');
      window.location.assign('/login');
    }
  };

  return { logout };
};
